// src/components/KnowledgeGraphView.js
import React, { useState, useEffect, useCallback } from 'react';
import { useOutletContext } from 'react-router-dom';
import KnowledgeGraphVisualization from './KnowledgeGraphVisualization'; // Assuming correct path


const KnowledgeGraphView = () => {
    const { apiService, clientId } = useOutletContext();

    const [networkData, setNetworkData] = useState({ nodes: [], links: [] });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Fetch network data (adapted from original Dashboard.js's overview load)
    const loadNetworkData = useCallback(async () => {
        if (!apiService || !clientId) return;
        setLoading(true); setError(null);
        try {
            // Use the new API method for network data
            const graphData = await apiService.getClientNetworkData(clientId);
            // Ensure we have a valid data structure with default values
            const safeData = {
                nodes: graphData?.nodes || [],
                links: graphData?.links || []
            };
            setNetworkData(safeData);
        } catch (err) {
            console.error('Error loading network data:', err);
            setError(err.message);
            setNetworkData({ nodes: [], links: [] });
        } finally {
            setLoading(false);
        }
    }, [apiService, clientId]);

    useEffect(() => {
        loadNetworkData();
    }, [loadNetworkData]);

    // Ensure networkData has the required properties
    const safeNetworkData = {
        nodes: networkData?.nodes || [],
        links: networkData?.links || []
    };

    return (
        <>
            <h2 className="text-xl font-semibold mb-6">Full Knowledge Graph</h2>
            {loading && <div className="text-center py-10">Loading Graph...</div>}
            {error && <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded">Error loading graph: {error}</div>}
            {!loading && !error && safeNetworkData.nodes.length > 0 && (
                <div className="bg-white rounded-lg shadow p-4" style={{ height: '600px' }}> {/* Add fixed height or adjust */}
                     <KnowledgeGraphVisualization graphData={safeNetworkData} />
                </div>
            )}
             {!loading && !error && safeNetworkData.nodes.length === 0 && (
                 <div className="text-center p-10 text-gray-500 bg-white rounded-lg shadow">No graph data loaded or available for this client.</div>
             )}
        </>
    );
};

export default KnowledgeGraphView;